import { useState, useEffect } from "react";
import moment from "moment";
import { postAxios } from "../../../util/postAxios";
import { today } from "../../../util/formatDate";
import * as XLSX from "xlsx";

export const useListRequest = () => {
  const getToken = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;

  const getTim = localStorage.getItem("user");
  const dataUser = JSON.parse(getTim);

  const [filterFrom, setFilterFrom] = useState(today);
  const [filterUntil, setFilterUntil] = useState(today);
  const [filterType, setFilterType] = useState("Pilih Type");
  const [filterBagian, setFilterBagian] = useState("Pilih Bagian");

  const [listDataRequest, setListDataRequest] = useState();
  const [paramSearch, setParamSearch] = useState("");

  const [subMenu, setSubMenu] = useState("Request");

  const [listRekapitulasi, setListRekapitulasi] = useState([]);

  const [searchBar, setSearchBar] = useState("");
  const [filterBulan, setFilterBulan] = useState(
    moment().utcOffset("+0700").month() + 1
  );
  const [filterTahun, setFilterTahun] = useState(
    moment().utcOffset("+0700").year()
  );
  const [kepalaBagian, setKepalaBagian] = useState("Pilih Kepala");

  const [isReload, setIsReload] = useState(false);

  const [filterFromRekap, setFilterFromRekap] = useState("");
  const [filterUntilRekap, setFilterUntilRekap] = useState("");

  const [dataChecklist, setDataChecklist] = useState();

  const [listFilterRange, setListFilterRange] = useState();
  const [popUpFilterRange, setPopUpFilterRange] = useState(false);
  const [listOperator, setListOperator] = useState();

  const [operatorPick, setOperatorPick] = useState();

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getRekapitulasi`,
      {
        tim: dataUser.tim,
        filterDate: `${filterTahun}-${("0" + filterBulan).slice(-2)}`,
        filterFrom: filterFromRekap,
        filterUntil: filterUntilRekap,
      },
      getToken,
      setListRekapitulasi,
      ""
    );

    setIsReload(false);
  }, [
    subMenu,
    filterBulan,
    filterTahun,
    isReload,
    filterFromRekap,
    filterUntilRekap,
  ]);

  useEffect(() => {
    if (subMenu === "Request" && !popUpFilterRange) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/revampRequest`,
        {
          tim: dataUser.tim,
          typeRequest: "getRequestHistoryDesktop",
          date: filterFrom,
        },
        getToken,
        setListDataRequest,
        ""
      );
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/editChecklistRequest`,
        {
          tim: dataUser.tim,
          data: dataChecklist,
        },
        getToken,
        setListRekapitulasi,
        ""
      );
      setTimeout(() => {
        setDataChecklist();
        setIsReload(false);
      }, 300);
    }
  }, [subMenu, filterFrom, isReload, dataChecklist]);

  useEffect(() => {
    if (popUpFilterRange && dataChecklist) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/editChecklistRequest`,
        { tim: dataUser.tim, data: dataChecklist },
        getToken,
        "",
        ""
      ).then?.(() => handleFindRange());
      setTimeout(() => setDataChecklist(), 300);
    }
  }, [dataChecklist]);

  const searchFeature = (params) => {
    return (
      listDataRequest &&
      listDataRequest.filter((value) => {
        const checkName =
          params === ""
            ? true
            : value.name?.toLowerCase().includes(params.toLowerCase());

        const checkType =
          filterType === "Pilih Type" ? true : value.typeRequest === filterType;

        const checkBagian =
          filterBagian === "Pilih Bagian"
            ? true
            : value.bagian === filterBagian;

        return checkName && checkType && checkBagian;
      })
    );
  };

  let dataTemp = searchFeature(paramSearch);

  const filteredData =
    listRekapitulasi &&
    listRekapitulasi.filter((item) => {
      const matchSearch =
        !searchBar || item.name.toLowerCase().includes(searchBar.toLowerCase());

      const matchKepala =
        kepalaBagian === "Pilih Kepala" || item.kepala === kepalaBagian;

      return matchSearch && matchKepala;
    });

  const uniqueNames = [
    ...new Set(listRekapitulasi && listRekapitulasi.map((item) => item.kepala)),
  ];

  const handleDeleteRequest = (id) => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/deleteRequest`,
      {
        requestId: id,
      },
      getToken,
      "",
      ""
    );
    setIsReload(true);
  };

  const handleExportRekapitulasi = async () => {
    try {
      const filtered =
        filteredData &&
        filteredData.map((obj, index) => {
          return {
            No: index + 1,
            Name: obj.name,
            Bagian: obj.bagian,
            Kepala: obj.kepala,
            S: obj.hariSakit,
            I: obj.hariIzin,
            A: obj.alpha,
            "Setengah Hari S": obj.setengahHariSakit,
            "Setengah Hari I": obj.setengahHariIzin,
          };
        });
      const workSheet = XLSX.utils.json_to_sheet(filtered && filtered);
      workSheet["!cols"] = [
        { wch: 4 },
        { wch: 32 },
        { wch: 19 },
        { wch: 13 },
        { wch: 4 },
        { wch: 4 },
        { wch: 4 },
        { wch: 14 },
        { wch: 14 },
      ];
      const workBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workBook, workSheet, "attendance");
      XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
      XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
      XLSX.writeFile(workBook, `Rekapitulasi.xlsx`);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/formLembur`,
      { tim: dataUser.tim, type: "getUserRequest" },
      getToken,
      setListOperator,
      ""
    );
  }, []);

  let reFormat = [];
  listOperator &&
    listOperator.forEach((element) => {
      reFormat.push({ value: element.id, label: element.name });
    });

  const handleFindRange = () => {
    if (!operatorPick?.value) {
      alert("Pilih operator terlebih dahulu");
      return;
    }

    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/revampRequest`,
      {
        tim: dataUser.tim,
        typeRequest: "getRequestHistoryRange",
        id: operatorPick.value,
        date: filterFrom,
        dateUntil: filterUntil,
      },
      getToken,
      setListFilterRange,
      ""
    );
  };

  const handleEditRequestTime = async (payload) => {
    try {
      // isBayar disimpan lewat endpoint editChecklistRequest (sama seperti
      // checkbox di tabel), jadi tidak ikut dikirim ke editRequestTime.
      const { isBayar, ...editPayload } = payload;

      const hasEditFields = Object.keys(editPayload).some(
        (k) => k !== "requestId"
      );

      if (hasEditFields) {
        await postAxios(
          `${process.env.REACT_APP_ENDPOINT}/revampRequest`,
          {
            tim: dataUser.tim,
            typeRequest: "editRequestTime",
            ...editPayload,
          },
          getToken,
          "",
          ""
        );
      }

      if (isBayar !== undefined) {
        // Sengaja tidak di-await: handler editChecklistRequest tidak
        // mengirim response saat sukses (pola sama dengan setDataChecklist).
        postAxios(
          `${process.env.REACT_APP_ENDPOINT}/editChecklistRequest`,
          {
            tim: dataUser.tim,
            data: { requestId: payload.requestId, isBayar },
          },
          getToken,
          "",
          ""
        );
      }

      setTimeout(() => {
        setIsReload(true);
        if (popUpFilterRange) handleFindRange();
      }, 500);
      return true;
    } catch (error) {
      alert("Gagal menyimpan perubahan. Coba lagi.");
      return false;
    }
  };

  return {
    filterFrom,
    setFilterFrom,
    filterUntil,
    setFilterUntil,
    paramSearch,
    setParamSearch,
    filterType,
    setFilterType,
    dataTemp,
    subMenu,
    setSubMenu,
    searchBar,
    setSearchBar,
    filterBulan,
    setFilterBulan,
    filterTahun,
    setFilterTahun,
    kepalaBagian,
    setKepalaBagian,
    uniqueNames,
    filteredData,
    handleDeleteRequest,
    filterFromRekap,
    setFilterFromRekap,
    filterUntilRekap,
    setFilterUntilRekap,
    handleExportRekapitulasi,
    setDataChecklist,
    popUpFilterRange,
    setPopUpFilterRange,
    handleFindRange,
    reFormat,
    operatorPick,
    setOperatorPick,
    listFilterRange,
    setListFilterRange,
    filterBagian,
    setFilterBagian,
    handleEditRequestTime,
  };
};
